import { useState } from 'react';

import { Check, ContentCopy } from 'icons';

export const CodeBlockCopyButton = ({ getText }: { getText: () => string }) => {
  const [copied, setCopied] = useState(false);

  const copy = () => {
    navigator.clipboard
      ?.writeText(getText())
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 1200);
      })
      .catch(() => undefined);
  };

  return (
    <button
      type="button"
      contentEditable={false}
      onMouseDown={(event) => event.preventDefault()}
      onClick={copy}
      aria-label="Copy code"
      className="absolute right-2 top-2 z-1 flex h-7 w-7 items-center justify-center rounded-md bg-[#2d2d2d] text-[#d4d4d4] opacity-60 transition hover:bg-[#3a3a3a] hover:opacity-100"
    >
      {copied ? <Check className="h-4 w-4 text-[#4EC9B0]" /> : <ContentCopy className="h-4 w-4" />}
    </button>
  );
};
